import React from "react"
import { Window, InfiniteScroll, View, Image, Text } from "react-ame-components"
import teamsWordCup from "../assets/json/wordCupTeams.json"

export class InfiniteScrollExample extends React.Component {
  state = {
    maxValue: 16,
    teams: teamsWordCup,
  }

  onEndReach = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        this.setState({
          maxValue: 32,
        })
        resolve()
      }, 3000)
    })
  }
  render() {
    return (
      <Window>
        <InfiniteScroll onEndReach={this.onEndReach}>
          {this.state.teams.map(
            (team, index) =>
              index <= this.state.maxValue && (
                <View
                  padding="extra-large"
                  display="flex"
                  align="center"
                  key={team.name}>
                  <Image
                    width="100px"
                    height="100px"
                    src="https://static.vecteezy.com/system/resources/previews/008/785/472/original/fifa-world-cup-qatar-2022-official-logo-mondial-champion-symbol-design-abstract-illustration-free-vector.jpg"
                  />
                  <Text>
                    {" "}
                    {team.name} - {team.country}
                  </Text>
                </View>
              ),
          )}
        </InfiniteScroll>
      </Window>
    )
  }
}
